import Vue from "vue";
import Router from "vue-router";
import { MessageBox, Message } from 'element-ui'

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  // 登录
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true,
    meta: { title: "登录" },
  },
  // 注册
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/register/index"),
    meta: {
      title: "",
      keepAlive: true,
    },
    hidden: true,
  },
  // 订阅
  {
    path: "/subscription",
    component: () => import("@/views/subscription/index"),
    hidden: true,
    meta: { title: "选择订阅" },
  },
  // 隐私政策
  {
    path: "/privacy",
    component: () => import("@/views/privacy/index"),
    meta: {
      title: "隐私政策",
    },
    hidden: true,
  },
  // 404
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },
  // 403
  {
    path: "/403",
    component: Layout,
    redirect: "/403",
    children: [
      {
        path: "/403",
        name: "403",
        component: () => import("@/views/403"),
        meta: { title: "暂无权限" },
      },
    ],
    hidden: true,
  },
  {
    path: "/",
    name: "home",
    redirect: "/home/board",
    meta: {
      title: "首页",
    },
    hidden: true,
  },
  // 首页
  {
    path: "/home",
    component: Layout,
    name: "home",
    redirect: "/home/board",
    alwaysShow: true,
    meta: {
      title: "首页",
    },
    children: [
      {
        path: "board",
        name: "board",
        component: () => import("@/views/home/index"),
        meta: {
          title: "首页",
          icon: "icon-shouyetianchong",
        },
        hidden: true,
      },
      // 我的订阅
      {
        path: "observe",
        component: () => import("@/views/home/business/index"),
        redirect: "/observe/sysOwn",
        alwaysShow: true,
        meta: {
          title: "我的订阅",
          icon: "icon-dingyue-guanzhu-05",
        },
        children: [
          {
            path: "sysOwn",
            name: "sysOwn",
            component: () => import("@/views/home/project/sysOwn/index"),
            meta: { title: "项目信息", },
          },
          
          {
            path: "purchase",
            name: "messagePurchase",
            component: () => import("@/views/home/purchase"),
            meta: {
              title: "采购信息",
              // icon: "icon-caigou",
            },
          },
        ]
      },
      // 我的采购
      {
        path: "product",
        name: "Product",
        //component: Layout,
        component: () => import("@/views/home/business/index"),
        redirect: "/product/quotation",
        alwaysShow: true,
        meta: { title: "我的采购", icon: "icon-caigou" },
        children: [
          {
            path: "quotation",
            name: "quotation",
            component: () => import("@/views/home/product/quotation/index"),
            meta: { title: "新品采购", },
          },
          {
            path: "quotation/detail",
            name: "quotationDetail",
            component: () => import("@/views/home/product/quotation/detail"),
            meta: {
              title: "采购详情",
              activeMenu: "/home/product/quotation",
            },
            hidden: true,
          },
          {
            path: "quotation/edit",
            name: "quotationEdit",
            component: () => import("@/views/home/product/quotation/edit"),
            meta: {
              title: "新增采购",
              activeMenu: "/home/product/quotation",
            },
            hidden: true,
          },
          {
            path: "quotation/report",
            name: "purchaseEnquiryReport",
            component: () => import("@/views/home/product/quotation/report"),
            meta: {
              title: "采购报告",
              activeMenu: "/home/product/quotation",
            },
            hidden: true,
          },
          {
            path: "outsource",
            name: "productOutsource",
            component: () => import("@/views/home/product/outsource/index"),
            meta: { title: "劳务外包", },
          },
          {
            path: "outsource/edit",
            name: "outsourceEdit",
            component: () => import("@/views/home/product/outsource/edit"),
            meta: {
              title: "劳务外包操作",
              activeMenu: "/home/product/outsource",
            },
            hidden: true,
          },
          {
            path: "outsource/detail",
            name: "outsourceDetail",
            component: () => import("@/views/home/product/outsource/detail"),
            meta: {
              title: "劳务外包详情",
              activeMenu: "/home/product/outsource",
            },
            hidden: true,
          },
          // {
          //   path: "together",
          //   name: "productTogether",
          //   component: () => import("@/views/product/together/index"),
          //   meta: { title: "拼单采购", icon: "icon-yiqipindansel" },
          // },
          {
            path: "used",
            name: "productUsed",
            component: () => import("@/views/home/product/used/index"),
            meta: { title: "二手物资", },
          },
          {
            path: "used/detail",
            name: "productDetail",
            component: () => import("@/views/home/product/used/detail"),
            meta: { title: "产品详情", activeMenu: "/home/product/used", },
            hidden: true,
          },
          {
            path: "used/edit",
            name: "productEdit",
            component: () => import("@/views/home/product/used/edit"),
            meta: { title: "物资", activeMenu: "/home/product/used", },
            hidden: true,
          },
        ],
      },
      // 我的报价 组件都是从原有组件中 带old文件夹中的组件
      {
        path: "enquiry",
        name: "Enquiry",
        //component: Layout,
        component: () => import("@/views/home/business/index"),
        alwaysShow: true,
        redirect: "/home/enquiry/enquiry",
        meta: { title: "我的报价", icon: "icon-qiandai" },
        children: [
          // 采购报价相关
          {
            path: "enquiry",
            name: "enquiry",
            component: () => import("@/views/home/product/quotation/quotationold/index"),
            meta: {
              title: "采购报价",
            },
          },
          {
            path: "enquiry/detail",
            name: "enquiryDetail",
            component: () => import("@/views/home/product/quotation/quotationold/detail"),
            meta: {
              title: "询价详情",
              activeMenu: "/home/product/enquiry",
            },
            hidden: true,
          },
          {
            path: "enquiry/edit",
            name: "enquiryEdit",
            component: () => import("@/views/home/product/quotation/quotationold/edit"),
            meta: {
              title: "询价编辑",
              activeMenu: "/home/product/enquiry",
            },
            hidden: true,
          },
          // 报价单 详情页面
          {
            path: "enquiry/reportdetail",
            name: "enquiryReportRetail",
            component: () => import("@/views/home/product/quotation/detailReport"),
            meta: {
              title: "询价详情页面",
              activeMenu: "/home/observe/purchase",
            },
            hidden: true,
          },

          // 劳务报价相关
          {
            path: "outsourceall",
            name: "outsourceall",
            component: () => import("@/views/home/product/outsource/outsourceold/index"),
            meta: {
              title: "劳务报价",
            },
          },
          {
            path: "outsourceall/detail",
            name: "outsourceallDetail",
            component: () => import("@/views/home/product/outsource/outsourceold/detail"),
            meta: {
              title: "报价详情",
              icon: "icon-wj-fa",
            },
            hidden: true,
          },
          {
            path: "outsourceall/edit",
            name: "outsourceallEdit",
            component: () => import("@/views/home/product/outsource/outsourceold/edit"),
            meta: {
              title: "劳务报价",
            },
            hidden: true,
          },

          {
            path: "outsourceall/reportdetail",
            name: "outsourceallReportRetail",
            component: () => import("@/views/home/product/outsource/detailReport"),
            meta: {
              title: "服务询价详情页面",
              activeMenu: "/home/observe/purchase",
            },
            hidden: true,
          },


          // 二手报价相关
          {
            path: "usedother",
            name: "productUsedOther",
            component: () => import("@/views/home/product/used/usedold/index"),
            meta: { title: "二手报价", },
          },
          {
            path: "usedother/report",
            name: "productReportOther",
            component: () => import("@/views/home/product/used/usedold/report"),
            meta: { title: "报价详情", activeMenu: "/product/usedother", },
            hidden: true,
          },
          {
            path: "usedother/edit",
            name: "productEditOther",
            component: () => import("@/views/home/product/used/usedold/edit"),
            meta: { title: "我要报价", activeMenu: "/product/usedother", },
            hidden: true,
          },
        ],
      },
      // 我的供应
      {
        path: "severs",
        name: "Severs",
        component: () => import("@/views/home/business/index"),
        redirect: "/severs/labour",
        alwaysShow: true,
        meta: { title: "我的供应", icon: "icon-gongyingshang" },
        children: [
          {
            path: "labour",
            name: "seversLabour",
            component: () => import("@/views/home/severs/labour/index"),
            meta: { title: "服务展示", },
          },
          {
            path: "labour/detail",
            name: "seversLabourDetail",
            component: () => import("@/views/home/severs/labour/detail"),
            meta: {
              title: "供应详情",
              activeMenu: "/home/severs/labour",
            },
            hidden: true,
          },
          {
            path: "labour/edit",
            name: "seversLabourEdit",
            component: () => import("@/views/home/severs/labour/edit"),
            meta: {
              title: "服务",
              activeMenu: "/home/severs/labour",
            },
            hidden: true,
          },
          {
            path: "showroom",
            name: "seversShowroom",
            component: () => import("@/views/home/severs/showroomhall/index"),
            meta: { title: "厂家展厅", },
          },
          {
            path: "showroom/detail",
            name: "provideShowroomDetail",
            component: () => import("@/views/home/severs/showroomhall/detail"),
            meta: {
              title: "产品详情",
            },
            hidden: true,
          },
          {
            path: "showroom/edit",
            name: "provideLabourEdit",
            component: () => import("@/views/home/severs/showroomhall/edit"),
            meta: {
              title: "产品",
            },
            hidden: true,
          },
          {
            path: "activity",
            name: "seversActivity",
            component: () => import("@/views/home/severs/activity/index"),
            meta: { title: "促销活动", },
          },
          {
            path: "activity/edit",
            name: "provideActivityEdit",
            component: () => import("@/views/home/severs/activity/edit"),
            meta: { title: "活动", },
            hidden: true,
          },
          {
            path: "activity/detail",
            name: "provideActivityDetail",
            component: () => import("@/views/home/severs/activity/detail"),
            meta: { title: "活动详情", },
            hidden: true,
          },
          {
            path: "used",
            name: "seversUsed",
            component: () => import("@/views/home/severs/used/index"),
            meta: { title: "二手物资", },
          },
          // 编辑和新增二手物资页面
          {
            path: "used/edit",
            name: "provideUsedEdit",
            component: () => import("@/views/home/severs/used/edit"),
            meta: {
              title: "产品",
            },
            hidden: true,
          },
          // 二手物资详情页面
          {
            path: "used/detail",
            name: "provideUsedDetail",
            component: () => import("@/views/home/severs/used/detail"),
            meta: {
              title: "产品详情",
            },
            hidden: true,
          },
          {
            path: "outmoded",
            name: "seversOutmoded",
            component: () => import("@/views/home/severs/outmoded/index"),
            meta: { title: "废旧物资", },
          },
          {
            path: "outmoded/detail",
            name: "outmodedUsedDetail",
            component: () => import("@/views/home/severs/outmoded/detail"),
            meta: {
              title: "产品详情",
            },
            hidden: true,
          },
          {
            path: "outmoded/edit",
            name: "outmodedUsedEdit",
            component: () => import("@/views/home/severs/outmoded/edit"),
            meta: {
              title: "产品",
            },
            hidden: true,
          },
        ],
      },
      // 我的收藏
      {
        path: "collect",
        component: () => import("@/views/home/business/index"),
        redirect: "/collect/projectCollect/list",
        alwaysShow: true,
        meta: {
          title: "我的收藏",
          icon: "icon-shoucang",
          keepAlive: true
        },
        children: [
          // 项目收藏
          {
            path: "projectCollect/list",
            name: "projectCollectLlist",
            component: () => import("@/views/project/projectCollect/list/index"),
            meta: {
              title: "项目收藏",
            },
          },
          // 企业收藏
          {
            path: "company/list",
            name: "resourceLlist",
            component: () => import("@/views/home/resource/company/list/index"),
            meta: {
              title: "企业伙伴资源",
              // icon: "icon-qiye",
            },
          },
          {
            path: "company/details",
            name: "resourceDetails",
            component: () => import("@/views/home/resource/company/details/index"),
            meta: {
              title: "企业信息详情",
              activeMenu: "/collect/company/list",
            },
            hidden: true,
          },
          // 个人资源收藏
          {
            path: "persion",
            name: "persion",
            component: () => import("@/views/home/resource/persionResource/index"),
            meta: {
              title: "个人伙伴",
              // icon: "icon-xingming",
            },
          },
          {
            path: "persion/detail",
            name: "personalResourcesDetail",
            component: () => import("@/views/home/resource/persionResource/detail"),
            meta: {
              title: "资源详情",
            },
            hidden: true,
          },
        ]
      },
      // 商机快讯
      {
        path: "business",
        name: "business",
        component: () => import("@/views/home/business/list"),
        meta: {
          title: "我的快讯",
          icon: "icon-24gf-newspaper3",
        },
      },
      {
        path: "business/edit",
        name: "edit",
        component: () => import("@/views/home/business/edit"),
        meta: {
          title: "发布快讯",
          icon: "icon-shouyetianchong",
          activeMenu: '/home/business'
        },
        hidden: true,
      },
      {
        path: "business/detail",
        name: "detail",
        component: () => import("@/views/home/business/detail"),
        meta: {
          title: "快讯详情",
          icon: "icon-shouyetianchong",
          activeMenu: '/home/business'
        },
        hidden: true,
      },
      // 我的项目
      {
        path: "enterprise",
        name: "projectEnterprise",
        component: () => import("@/views/home/project/enterprise/index"),
        meta: { title: "我的项目", icon: "icon-xiangmu", },
      },
      {
        path: "enterprise/detail",
        name: "enterpriseDetail",
        component: () => import("@/views/home/project/enterprise/detail"),
        meta: {
          title: "项目详情",
          activeMenu: "/home/enterprise",
          //keepAlive:true,
        },
        hidden: true
      },
      {
        path: "enterprise/edit",
        name: "EnterpriseEdit",
        component: () => import("@/views/home/project/enterprise/edit"),
        meta: {
          title: "项目操作",
          activeMenu: "/home/enterprise",
          // keepAlive: true
        },
        hidden: true,
      },
      // 我的资料库
      {
        path: "technique",
        name: "technique",
        component: () => import("@/views/home/resource/Information/index"),
        meta: {
          title: "我的资料库",
          icon: "icon-ziliaoku",
        },
      },
      {
        path: "technique/edit",
        name: "InformationEdit",
        component: () => import("@/views/home/resource/Information/edit"),
        meta: {
          title: "资料",
          activeMenu: '/home/technique'
        },
        hidden: true,
      },
      {
        path: "technique/detail",
        name: "InformationDetail",
        component: () => import("@/views/home/resource/Information/detail"),
        meta: {
          title: "资料详情",
          activeMenu: '/home/technique'
        },
        hidden: true,
      },
    ],
  },
  // 项目
  {
    path: "/project",
    name: "project",
    component: Layout,
    redirect: "/project/observe/sysOwn",
    alwaysShow: true,
    meta: { title: "项目" },
    children: [
      {
        path: "observe",
        component: () => import("@/views/home/business/index"),
        meta: {
          title: "项目信息",
          icon: "icon-dingyue-guanzhu-05",
        },
        children: [
          {
            path: "sysOwn",
            name: "sysOwn",
            component: () => import("@/views/project/sysOwn/index"),
            meta: { title: "项目信息", },
          },
          {
            path: "purchase",
            name: "messagePurchase",
            component: () => import("@/views/system/account/subscription"),
            meta: { title: "个性定制", },
          },
        ]
      },
      {
        path: "zhaobiao",
        name:"projectZhaobiao",
        component: () => import("@/views/project/enterprise/index"),
        meta: {
          title: "我要招标",
          icon: "icon-xiangmu",
        },
      },
      {
        path: "enterprise/detail",
        name: "enterpriseDetail",
        component: () => import("@/views/project/enterprise/detail"),
        meta: {
          title: "项目详情",
          activeMenu: "/project/zhaobiao",
          //keepAlive:true,
        },
        hidden: true
      },
      {
        path: "enterprise/edit",
        name: "EnterpriseEdit",
        component: () => import("@/views/project/enterprise/edit"),
        meta: {
          title: "项目操作",
          activeMenu: "/project/zhaobiao",
          // keepAlive: true
        },
        hidden: true,
      },
    ]
  },
  // 采购
  {
    path: "/caigou",
    name: "caigou",
    component: Layout,
    redirect: "/caigou/product/quotation",
    alwaysShow: true,
    meta: { title: "采购" },
    children: [
      // 我的采购
      {
        path: "product",
        name: "Product",
        component: () => import("@/views/home/business/index"),
        redirect: "/product/quotation",
        alwaysShow: true,
        meta: { title: "我的采购", icon: "icon-caigou" },
        children: [
          {
            path: "quotation",
            name: "quotation",
            component: () => import("@/views/product/quotation/index"),
            meta: { title: "新品采购", },
          },
          {
            path: "quotation/detail",
            name: "quotationDetail",
            component: () => import("@/views/product/quotation/detail"),
            meta: {
              title: "采购详情",
              activeMenu: "/caigou/product/quotation",
            },
            hidden: true,
          },
          {
            path: "quotation/edit",
            name: "quotationEdit",
            component: () => import("@/views/product/quotation/edit"),
            meta: {
              title: "新增采购",
              activeMenu: "/caigou/product/quotation",
            },
            hidden: true,
          },
          {
            path: "quotation/report",
            name: "purchaseEnquiryReport",
            component: () => import("@/views/product/quotation/report"),
            meta: {
              title: "采购报告",
              activeMenu: "/caigou/product/quotation",
            },
            hidden: true,
          },
          {
            path: "outsource",
            name: "productOutsource",
            component: () => import("@/views/product/outsource/index"),
            meta: { title: "劳务外包", },
          },
          {
            path: "outsource/edit",
            name: "outsourceEdit",
            component: () => import("@/views/product/outsource/edit"),
            meta: {
              title: "劳务外包操作",
              activeMenu: "/caigou/product/outsource",
            },
            hidden: true,
          },
          {
            path: "outsource/detail",
            name: "outsourceDetail",
            component: () => import("@/views/product/outsource/detail"),
            meta: {
              title: "劳务外包详情",
              activeMenu: "/caigou/product/outsource",
            },
            hidden: true,
          },
          {
            path: "used",
            name: "productUsed",
            component: () => import("@/views/product/used/index"),
            meta: { title: "二手物资", },
          },
          {
            path: "used/detail",
            name: "productDetail",
            component: () => import("@/views/product/used/detail"),
            meta: { title: "产品详情", activeMenu: "/home/product/used", },
            hidden: true,
          },
          {
            path: "used/edit",
            name: "productEdit",
            component: () => import("@/views/product/used/edit"),
            meta: { title: "物资", activeMenu: "/caigou/product/used", },
            hidden: true,
          },
        ],
      },
      // 我的报价 组件都是从原有组件中 带old文件夹中的组件
      {
        path: "enquiry",
        name: "Enquiry",
        component: () => import("@/views/home/business/index"),
        alwaysShow: true,
        redirect: "/home/enquiry/enquiry",
        meta: { title: "我的报价", icon: "icon-qiandai" },
        children: [
          // 采购报价相关
          {
            path: "enquiry",
            name: "enquiry",
            component: () => import("@/views/product/quotation/quotationold/index"),
            meta: {
              title: "采购报价",
            },
          },
          {
            path: "enquiry/detail",
            name: "enquiryDetail",
            component: () => import("@/views/product/quotation/quotationold/detail"),
            meta: {
              title: "询价详情",
              activeMenu: "/caigou/product/enquiry",
            },
            hidden: true,
          },
          {
            path: "enquiry/edit",
            name: "enquiryEdit",
            component: () => import("@/views/product/quotation/quotationold/edit"),
            meta: {
              title: "询价编辑",
              activeMenu: "/caigou/product/enquiry",
            },
            hidden: true,
          },
          // 报价单 详情页面
          {
            path: "enquiry/reportdetail",
            name: "enquiryReportRetail",
            component: () => import("@/views/product/quotation/detailReport"),
            meta: {
              title: "询价详情页面",
              activeMenu: "/caigou/observe/purchase",
            },
            hidden: true,
          },

          // 劳务报价相关
          {
            path: "outsourceall",
            name: "outsourceall",
            component: () => import("@/views/product/outsource/outsourceold/index"),
            meta: {
              title: "劳务报价",
            },
          },
          {
            path: "outsourceall/detail",
            name: "outsourceallDetail",
            component: () => import("@/views/product/outsource/outsourceold/detail"),
            meta: {
              title: "报价详情",
              icon: "icon-wj-fa",
            },
            hidden: true,
          },
          {
            path: "outsourceall/edit",
            name: "outsourceallEdit",
            component: () => import("@/views/product/outsource/outsourceold/edit"),
            meta: {
              title: "劳务报价",
            },
            hidden: true,
          },

          {
            path: "outsourceall/reportdetail",
            name: "outsourceallReportRetail",
            component: () => import("@/views/product/outsource/detailReport"),
            meta: {
              title: "服务询价详情页面",
              activeMenu: "/caigou/observe/purchase",
            },
            hidden: true,
          },
          // 二手报价相关
          {
            path: "usedother",
            name: "productUsedOther",
            component: () => import("@/views/product/used/usedold/index"),
            meta: { title: "二手报价", },
          },
          {
            path: "usedother/report",
            name: "productReportOther",
            component: () => import("@/views/product/used/usedold/report"),
            meta: { title: "报价详情", activeMenu: "/caigou/product/usedother", },
            hidden: true,
          },
          {
            path: "usedother/edit",
            name: "productEditOther",
            component: () => import("@/views/product/used/usedold/edit"),
            meta: { title: "我要报价", activeMenu: "/caigou/product/usedother", },
            hidden: true,
          },
        ],
      },
    ]
  },
  // 供应
  {
    path: "/gongyin",
    name: "gongyin",
    component: Layout,
    redirect: "/gongyin/severs/labour",
    alwaysShow: true,
    meta: { title: "供应" },
    children: [
      {
        path: "severs",
        name: "Severs",
        component: () => import("@/views/home/business/index"),
        redirect: "/severs/labour",
        alwaysShow: true,
        meta: { title: "我的供应", icon: "icon-gongyingshang" },
        children: [
          {
            path: "labour",
            name: "seversLabour",
            component: () => import("@/views/severs/labour/index"),
            meta: { title: "服务展示", },
          },
          {
            path: "labour/detail",
            name: "seversLabourDetail",
            component: () => import("@/views/severs/labour/detail"),
            meta: {
              title: "供应详情",
              activeMenu: "/gongyin/severs/labour",
            },
            hidden: true,
          },
          {
            path: "labour/edit",
            name: "seversLabourEdit",
            component: () => import("@/views/severs/labour/edit"),
            meta: {
              title: "服务",
              activeMenu: "/gongyin/severs/labour",
            },
            hidden: true,
          },
          // 第二版
          {
            path: "showroom",
            name: "seversShowroom",
            component: () => import("@/views/severs/showroomhall/index"),
            meta: { title: "厂家展厅", },
          },
          {
            path: "showroom/detail",
            name: "provideShowroomDetail",
            component: () => import("@/views/severs/showroomhall/detail"),
            meta: {
              title: "产品详情",
            },
            hidden: true,
          },
          {
            path: "showroom/edit",
            name: "provideLabourEdit",
            component: () => import("@/views/severs/showroomhall/edit"),
            meta: {
              title: "产品",
            },
            hidden: true,
          },
          {
            path: "activity",
            name: "seversActivity",
            component: () => import("@/views/severs/activity/index"),
            meta: { title: "促销活动", },
          },
          {
            path: "activity/edit",
            name: "provideActivityEdit",
            component: () => import("@/views/severs/activity/edit"),
            meta: { title: "活动", },
            hidden: true,
          },
          {
            path: "activity/detail",
            name: "provideActivityDetail",
            component: () => import("@/views/severs/activity/detail"),
            meta: { title: "活动详情", },
            hidden: true,
          },
          {
            path: "used",
            name: "seversUsed",
            component: () => import("@/views/severs/used/index"),
            meta: { title: "二手物资", },
          },
          // 编辑和新增二手物资页面
          {
            path: "used/edit",
            name: "provideUsedEdit",
            component: () => import("@/views/severs/used/edit"),
            meta: {
              title: "产品",
            },
            hidden: true,
          },
          // 二手物资详情页面
          {
            path: "used/detail",
            name: "provideUsedDetail",
            component: () => import("@/views/severs/used/detail"),
            meta: {
              title: "产品详情",
            },
            hidden: true,
          },
          {
            path: "outmoded",
            name: "seversOutmoded",
            component: () => import("@/views/severs/outmoded/index"),
            meta: { title: "废旧物资", },
          },
          {
            path: "outmoded/detail",
            name: "outmodedUsedDetail",
            component: () => import("@/views/severs/outmoded/detail"),
            meta: {
              title: "产品详情",
            },
            hidden: true,
          },
          {
            path: "outmoded/edit",
            name: "outmodedUsedEdit",
            component: () => import("@/views/severs/outmoded/edit"),
            meta: {
              title: "产品",
            },
            hidden: true,
          },
          {
            path: "enterprise",
            name: "companyEnterprise",
            component: () => import("@/views/system/company/enterprise/index"),
            meta: { title: "企业产品库", },
          },
          {
            path: "enterprise/edit",
            name: "companyEnterpriseEdit",
            component: () => import("@/views/system/company/enterprise/edit"),
            meta: {
              title: "企业产品操作",
              activeMenu: "/gongyin/severs/enterprise",
            },
            hidden: true,
          },
          {
            path: "enterprise/detail",
            name: "companyEnterpriseDetail",
            component: () => import("@/views/system/company/enterprise/detail"),
            meta: {
              title: "产品详情",
              activeMenu: "/gongyin/severs/enterprise",
            },
            hidden: true,
          },
        ],
      },

    ]
  },
  // 服务
  {
    path: "/fuwu",
    name: "fuwu",
    component: Layout,
    redirect: "/project/xinyong/query",
    alwaysShow: true,
    meta: { title: "服务" },
    children: [
      {
        path: "xinyong",
        component: () => import("@/views/project/xinyong/index"),
        redirect: "/fuwu/xinyong/query",
        alwaysShow: true,
        meta: {
          title: "司法查询",
          icon: "icon-dingyue-guanzhu-05",
        },
        children: [
          {
            path: "query",
            name: "query",
            component: () => import("@/views/project/xinyong/query/index"),
            meta: { title: "信用查询",activeMenu: "/fuwu/xinyong/query" },
          },
          {
            path: "company",
            name: "companyResult",
            component: () => import("@/views/project/xinyong/query/company"),
            meta: { title: "查询结果", activeMenu: "/fuwu/xinyong/query", },
            hidden: true,
          },
          {
            path: "persion",
            name: "persion",
            component: () => import("@/views/project/xinyong/query/persion"),
            meta: { title: "查询结果", activeMenu: "/fuwu/xinyong/query", },
            hidden: true,
          },
          {
            path: "history",
            name: "history",
            component: () => import("@/views/project/xinyong/history/index"),
            meta: { title: "查询记录", },
          },
          {
            path: "vip",
            name: "vip",
            component: () => import("@/views//project/xinyong/vip/index"),
            meta: { title: "购买权益", },
          },
        ]
      },
      {
        path: "daikuan",
        name: 'daikuanList',
        component: () => import("@/views/project/rongzi/daikuan/list"),
        meta: {
          title: "融资贷款",
          icon: "el-icon-s-shop",
        },
      },
      {
        path: "daikuanedit",
        name: 'daikuanEdit',
        component: () => import("@/views/project/rongzi/daikuan/edit"),
        meta: {
          title: "贷款",
          activeMenu: "/fuwu/daikuan",
        },
        hidden: true,
      },
      {
        path: "daikuancaiji",
        name: 'daikuanCaiji',
        component: () => import("@/views/project/rongzi/daikuan/caiji"),
        meta: {
          title: "信息采集",
          activeMenu: "/fuwu/daikuan",
        },
        hidden: true,
      },
      {
        path: "zulin",
        name: 'zulinList',
        component: () => import("@/views/project/rongzi/zulin/list"),
        meta: {
          title: "设备租赁",
          icon: "icon-xiangmu",
        },
      },
      {
        path: "zulinedit",
        name: 'zulinEdit',
        component: () => import("@/views/project/rongzi/zulin/edit"),
        meta: {
          title: "租赁",
          activeMenu: "/fuwu/zulin",
        },
        hidden: true,
      },
      {
        path: "zulincaiji",
        name: 'zulinCaiji',
        component: () => import("@/views/project/rongzi/zulin/caiji"),
        meta: {
          title: "信息采集",
          activeMenu: "/fuwu/zulin",
        },
        hidden: true,
      },
      // 其他服务
      {
        path: "qita",
        name: 'qitaList',
        component: () => import("@/views/project/rongzi/qita/list"),
        meta: {
          title: "其他服务",
          icon: "icon-xiangmu",
        },
      },
      {
        path: "qitacaiji",
        name: 'qitaCaiji',
        component: () => import("@/views/project/rongzi/qita/caiji"),
        meta: {
          title: "信息采集",
          activeMenu: "/fuwu/qita",
        },
        hidden: true,
      },
      {
        path: "qitaedit",
        name: 'qitaEdit',
        component: () => import("@/views/project/rongzi/qita/edit"),
        meta: {
          title: "发布服务",
          activeMenu: "/fuwu/qita",
        },
        hidden: true,
      },
    ]
  },
  // 伙伴
  {
    path: "/houban",
    name: "houban",
    component: Layout,
    redirect: "/houban/company/list",
    alwaysShow: true,
    meta: { title: "伙伴" },
    children: [
      {
        path: "company/list",
        name: "resourceLlist",
        component: () => import("@/views/resource/company/list/index"),
        meta: {
          title: "企业伙伴",
          icon: "icon-qiye",
        },
      },
      {
        path: "company/details",
        name: "resourceDetails",
        component: () => import("@/views/resource/company/details/index"),
        meta: {
          title: "企业信息详情",
          activeMenu: "/houban/company/list",
        },
        hidden: true,
      },
      {
        path: "persion",
        name: "persion",
        component: () => import("@/views/resource/persionResource/index"),
        meta: {
          title: "个人伙伴",
          icon: "icon-xingming",
        },
      },
      {
        path: "persion/detail",
        name: "personalResourcesDetail",
        component: () => import("@/views/resource/persionResource/detail"),
        meta: {
          title: "资源详情",
        },
        hidden: true,
      },
    ]
  },
  // 人才
  {
    path: "/rencai",
    name: "rencai",
    component: Layout,
    redirect: "/rencai/joinInfo/list",
    alwaysShow: true,
    meta: { title: "人才" },
    children: [
      {
        path: "joinInfo/list",
        name: "joinInfoList",
        component: () =>
          import("@/views/recruitment/joinInfo/list/index"),
        meta: { title: "职位管理", icon: "icon-qiye", },
      },
      {
        path: "joinInfo/details",
        name: "performanceDetails",
        component: () =>
          import("@/views/recruitment/joinInfo/details/index"),
        meta: {
          title: "职位信息详情",
          activeMenu: "/rencai/joinInfo/list",
        },
        hidden: true,
      },
      {
        path: "joinInfo/compile",
        name: "performanceCompile",
        component: () =>
          import("@/views/recruitment/joinInfo/compile/index"),
        meta: {
          title: "编辑/新增招聘信息",
          activeMenu: "/rencai/joinInfo/list",
        },
        hidden: true,
      },
      {
        path: "talent",
        name: "recruitmentTalent",
        component: () => import("@/views/recruitment/talent/index"),
        meta: { title: "人才库", icon: "icon-xingming", },
      },
      {
        path: "join",
        name: "messageJoin",
        component: () => import("@/views/recruitment/join"),
        meta: { title: "招聘互动", icon: "icon-mn_hudong_fill" },
      },
      {
        path: "talent/detail",
        name: "talentDetail",
        component: () => import("@/views/recruitment/talent/detail"),
        meta: {
          title: "简历详情",
          activeMenu: "/rencai/talent",
        },
        hidden: true,
      },
    ]
  },
  // 求职
  {
    path: "/jobwanted",
    name: "jobwanted",
    component: Layout,
    redirect: "/jobWanted/resume",
    alwaysShow: true,
    meta: { title: "求职" },
    children: [
      {
        path: "resume",
        name: "resume",
        component: () => import("@/views/jobWanted/resume"),
        meta: { title: "我的简历", activeMenu: "/jobwanted/resume", icon: 'icon-resume-s' },
      },
      {
        path: "jobs",
        name: "recruitmentJobs",
        component: () => import("@/views/jobWanted/jobs/index"),
        meta: { title: "招聘信息", icon: "icon-pipeizhiwei" },
      },
      {
        path: "jobs/detail",
        name: "jobsDetail",
        component: () => import("@/views/jobWanted/jobs/detail"),
        meta: {
          title: "职位详情",
          activeMenu: "/jobwanted/jobs",
        },
        hidden: true,
      },
      {
        path: "applyJob",
        name: "messageApplyJob",
        component: () => import("@/views/jobWanted/applyJob"),
        meta: {
          title: "求职消息",
          activeMenu: '/jobwanted/applyJob',
          icon: 'icon-mn_hudong_fill'
        },
      },
    ],
  },
  // 消息
  {
    path: "/message",
    component: Layout,
    name: "message",
    redirect: '/message/systemNotice/list',
    alwaysShow: true,
    meta: {
      title: "消息",
    },
    children: [
      {
        path: "systemNotice/list",
        name: "list",
        component: () => import("@/views/message/systemNotice/list/index"),
        meta: {
          title: "系统消息",
          icon: "icon-gonggao",
        },
      },
      {
        path: "systemNotice/details",
        name: "systemNoticeDetails",
        component: () =>
          import("@/views/message/systemNotice/details/index"),
        meta: {
          title: "系统消息详情",
          activeMenu: "/message/systemNotice/list",
        },
        hidden: true,
      },
      {
        path: "comment/list",
        name: "comment",
        component: () => import("@/views/message/commentMessage/list"),
        meta: {
          title: "互动消息",
          icon: "icon-mn_hudong_fill",
        },
      },
      {
        path: "session/list",
        name: "session",
        component: () => import("@/views/message/sessionMessage/list"),
        meta: {
          title: "私信消息",
          icon: "icon-w_liuyan",
        },
      },
      {
        path: "systemNews/list",
        name: "systemNews",
        component: () => import("@/views/dynamicNews/systemNews/list/index"),
        meta: {
          title: "行业新闻",
          icon: "icon-qiye",
        },
      },
      {
        path: "systemNews/details",
        name: "systemdetails",
        component: () => import("@/views/dynamicNews/systemNews/details/index"),
        meta: {
          title: "行业新闻详情",
          icon: "icon-gonggao",
          activeMenu:'/message/systemNews/list',
        },
        hidden:true
      },
      {
        path: "companyNews/list",
        name: "companyNews",
        component: () => import("@/views/dynamicNews/companyNews/list/index"),
        meta: {
          title: "会员动态",
          icon: "icon-xingming",
        },
      },
      {
        path: "companyNews/details",
        name: "companydetails",
        component: () => import("@/views/dynamicNews/companyNews/details/index"),
        meta: {
          title: "会员动态详情",
          icon: "icon-gonggao",
          activeMenu:'/message/companyNews/list',
        },
        hidden:true
      },
      // {
      //   path: "systemNotice/list",
      //   name: "list",
      //   component: () => import("@/views/message/systemNotice/list/index"),
      //   meta: {
      //     title: "觅特优选",
      //     icon: "icon-gonggao",
      //   },
      // },
    ],
  },
  // 设置
  {
    path: "/shezhi",
    name: "shezhi",
    component: Layout,
    redirect: "/shezhi/company/info",
    alwaysShow: true,
    meta: { title: "设置" },
    children: [
      // 企业管理
      {
        path: "company",
        meta: { title: "企业管理", icon: 'icon-qiye' },
        alwaysShow: true,
        redirect: "/shezhi/company/info",
        component: () => import("@/views/system/index"),
        children: [
          {
            path: "info",
            name: "companyInfo",
            component: () => import("@/views/system/company/companyInfo"),
            meta: { title: "企业认证", },
          },
          {
            path: "contacts/list",
            name: "contactsList",
            component: () => import("@/views/system/company/contacts/list"),
            meta: { title: "企业账号管理", },
          },
          {
            path: "contacts/compile",
            name: "contactsCompile",
            component: () => import("@/views/system/company/contacts/compile"),
            meta: {
              title: "企业联系人编辑",
              activeMenu: "/shezhi/company/contacts/list",
            },
            hidden: true,
          },
          {
            path: "publicity/list",
            name: "publicityList",
            component: () =>
              import("@/views/system/company/publicity/list/index"),
            meta: { title: "企业动态", },
          },
          {
            path: "publicity/details",
            name: "publicityDetails",
            component: () =>
              import("@/views/system/company/publicity/details/index"),
            meta: {
              title: "企业动态详情",
              activeMenu: "/shezhi/company/publicity/list",
            },
            hidden: true,
          },
          {
            path: "publicity/compile",
            name: "publicityCompile",
            component: () =>
              import("@/views/system/company/publicity/compile/index"),
            meta: {
              title: "编辑/新增企业动态",
              activeMenu: "/shezhi/company/publicity/list",
            },
            hidden: true,
          },
          {
            path: "certification/list",
            name: "certificationList",
            component: () =>
              import("@/views/system/company/certification/list/index"),
            meta: { title: "企业资质", },
          },
          {
            path: "certification/details",
            name: "certificationDetails",
            component: () =>
              import("@/views/system/company/certification/details/index"),
            meta: {
              title: "企业资质详情",
              activeMenu: "/shezhi/company/certification/list",
            },
            hidden: true,
          },
          {
            path: "certification/compile",
            name: "certificationCompile",
            component: () =>
              import("@/views/system/company/certification/compile/index"),
            meta: {
              title: "编辑/新增企业资质",
              activeMenu: "/shezhi/company/certification/list",
            },
            hidden: true,
          },
          {
            path: "honor/list",
            name: "honorList",
            component: () => import("@/views/system/company/honor/list/index"),
            meta: { title: "荣誉证书", },
          },
          {
            path: "honor/details",
            name: "honorDetails",
            component: () =>
              import("@/views/system/company/honor/details/index"),
            meta: {
              title: "企业荣誉详情",
              activeMenu: "/shezhi/company/honor/list",
            },
            hidden: true,
          },
          {
            path: "honor/compile",
            name: "honorCompile",
            component: () =>
              import("@/views/system/company/honor/compile/index"),
            meta: {
              title: "编辑/新增企业荣誉",
              activeMenu: "/shezhi/company/honor/list",
            },
            hidden: true,
          },
          {
            path: "performance/list",
            name: "performanceList",
            component: () =>
              import("@/views/system/company/performance/list/index"),
            meta: { title: "工程业绩", },
          },
          {
            path: "performance/details",
            name: "performanceDetails",
            component: () =>
              import("@/views/system/company/performance/details/index"),
            meta: {
              title: "工程业绩详情",
              activeMenu: "/shezhi/company/performance/list",
            },
            hidden: true,
          },
          {
            path: "performance/compile",
            name: "performanceCompile",
            component: () =>
              import("@/views/system/company/performance/compile/index"),
            meta: {
              title: "编辑/新增工程业绩",
              activeMenu: "/shezhi/company/performance/list",
            },
            hidden: true,
          },
          {
            path: "browse",
            name: "browseLlist",
            component: () => import("@/views/system/company/browse/index"),
            meta: {
              title: "谁看过我",
            },
          },
          {
            path: "pricetable",
            name: "pricetable",
            component: () => import("@/views/system/pricetable/index"),
            meta: { title: "产品价格表", },
          },
        ],

      },
      // 个人中心
      {
        path: "geren",
        component: () => import("@/views/system/index"),
        redirect: "/geren/account/information",
        name: "geren",
        meta: { title: "个人中心", icon: 'icon-lianxiren' },
        children: [
          {
            path: "account/information",
            name: "information",
            component: () => import("@/views/system/account/information"),
            meta: { title: "个人资料", },
          },
          {
            path: "account/password",
            name: "password",
            component: () => import("@/views/system/account/password"),
            meta: { title: "修改密码", },
          },
          {
            path: "account/wechat",
            name: "wechat",
            component: () => import("@/views/system/account/wechat"),
            meta: { title: "绑定公众号", },
          },
          {
            path: "account/subscription",
            name: "subscription",
            component: () => import("@/views/system/account/subscription"),
            meta: { title: "订阅管理", },
          },
          {
            path: "account/integral",
            name: "integral",
            component: () => import("@/views/system/account/integral"),
            meta: { title: "我的积分", },
          },
          {
            path: "account/order",
            name: "order",
            component: () => import("@/views/system/account/order"),
            meta: { title: "我的订单", },
          },
          {
            path: "account/invoice",
            name: "invoice",
            component: () => import("@/views/system/account/invoice"),
            meta: { title: "我的发票", },
          },
        ],
      },
    ]
  },
  {
    path: '/report',
    component: () => import("@/views/report/index"),
    meta: { title: "采购报告", icon: "xinxi", pitchIcon: "xinxi-pitch" },
    name: 'report',
    hidden: true
  },
  {
    path: '/offerreport',
    component: () => import("@/views/offerreport/index"),
    meta: { title: "报价报告", icon: "xinxi", pitchIcon: "xinxi-pitch" },
    name: 'offerReport',
    hidden: true
  },
  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    // scrollBehavior: () => ({ y: 0 }),
    scrollBehavior(to, from, savePosition) {
      if (savePosition) {
        //解决页面从列表页跳转到详情页返回,初始在原来位置
        return savePosition;
      } else {
        //解决页面跳转后页面高度和前一个页面高度一样
        return { x: 0, y: 0 };
      }
    },
    routes: constantRoutes,
  });

const router = createRouter();
const IEVersion = () => {
  let UserAgent = navigator.userAgent
  let isIE = UserAgent.indexOf('compatible') > -1 && UserAgent.indexOf('MSIE') > -1; // 是否为IE<11 浏览器
  let isEdge = UserAgent.indexOf('Edge') > -1;  // 是否为Edge 浏览器
  let isIE11 = UserAgent.indexOf('Trident') > -1 && UserAgent.indexOf('rv:11.0') > -1;  // 是否为IE = 11 浏览器
  if (isIE) {
    return true
  } else if (isEdge) {
    return false
  } else if (isIE11) {
    return true
  } else {
    return false
  }
}
// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 判断浏览器兼容性
  if (IEVersion()) {
    // IE浏览器 需要提示用户 使用推荐浏览器
    console.log('当前使用IE浏览器')
    MessageBox.confirm('系统未完全支持低版本IE浏览器,建议下载微软官方Edge浏览器或者谷歌浏览器', '警告', {
      type: 'warning',
      confirmButtonText: '我知道了',
      cancelButtonText: '取消',
    });
  } else {
    console.log('当前使用非浏览器')
    next()
  }

})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
